module.exports = __webpack_public_path__ + "static/media/baseline-table_chart-24px.5191bb7d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/baseline-table_chart-24px.svg
// module id = 772
// module chunks = 0